import { Common, ApiBind } from './common.model';
import { Tester } from './tester.model';

export class TesterGroup extends Common {

  @ApiBind({ column: 'id' })
  id: number;

  @ApiBind({ column: 'name' })
  name: string;

  @ApiBind({ column: 'testers', model: (values) => values.map(value => new Tester(value)) })
  testers: Tester[];

}
